import { Injectable } from '@angular/core';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { QuestionStoreModel } from '@examdojo/question';
import { of } from 'rxjs';

@Injectable()
export class QuestionListService extends AbstractSimpleListViewService<QuestionStoreModel> {
  constructor() {
    super();
  }

  readonly data$ = of([]);
  readonly loading$ = of(false);
  override hasItems$ = of(true);
}
